module.exports = __webpack_public_path__ + "static/media/logo.0aa1a741.png";